// extracted by mini-css-extract-plugin
export default {"aboutme_wrap":"aboutme_aboutme_wrap__aV69E","aboutme_links":"aboutme_aboutme_links__E1C4J","aboutme_img":"aboutme_aboutme_img__+rT-a"};